import cookie from 'js-cookie'
export default {
    install(Vue, options) {
        Vue.prototype.getCurrentEnv = function() {
            /*
            local          --           本地调试
            ckl            --           内网
            test           --           外测
            production     --           生产
            */
            return 'test'
        }

        Vue.prototype.getWSDomain = function() {
            let env = this.getCurrentEnv();
            let protocol = location.protocol;
            let origin = protocol + '//ws.ckl.com';
            console.log('protocol:', protocol);
            
            if (env == 'test') {
                origin = protocol + '//test-ws.forclass.net';
            }
            if (env == 'production') {
                origin = protocol + '//webservice.forclass.net';
            }

            return origin
        }

        Vue.prototype.getWebServiceURL = function(m) {
            return "/ANAService.asmx/" + m
        }

        Vue.prototype.getPaasServiceURL = function(m) {
            return "/PaasService.asmx/" + m
        }

        Vue.prototype.getSession = function() {
            var acnt = this.loadAccount()
            if (this.isValid(acnt) &&
                this.isValid(acnt.session)) {
                return acnt.session
            }
        }

        Vue.prototype.getSessionVal = function(key) {
            var value = (typeof sessionStorage[key] == "undefined" || sessionStorage[key] == "undefined") ? "" : sessionStorage[key]
            return value
        }

        Vue.prototype.getCookie = function(name) {
            return cookie.getJSON(name)
        }

        Vue.prototype.isSupportJSON = function() {
            var support = JSON != null && typeof JSON != 'undefined'
            if (!support && !g_upgrademsgshowed) {
                g_upgrademsgshowed = true
                alert("您的浏览器版本过低，请升级浏览器。")
            }

            return support
        }

        Vue.prototype.loadAccount = function() {
            /*
            if (this.isValid(sessionStorage.account) && this.isSupportJSON()) {
                return JSON.parse(sessionStorage.account)
            } else if (this.isValid(this.getCookie('account')) && this.isSupportJSON()) {
                return this.getCookie('account')
            }
            */

            /*if (this.isValid(this.getCookie('account')) && this.isSupportJSON()) {
                return this.getCookie('account')
            }
            return null*/
            let device = this.getSessionVal('device') || window.navigator.userAgent.toLowerCase().indexOf('wke') >= 0
            let tool = this.getSessionVal('tool')
            let clientBrowser = device || tool
            let account = null
                //客户端（教师端，学生端）浏览器允许使用sessionStorage；PC浏览器只允许使用Cookie
            if (this.isSupportJSON()) {
                let cookieAccount = this.getCookie('account')
                let sessionAccount = this.getSessionVal('account')
                if (clientBrowser && this.isValid(sessionAccount) && sessionAccount != '') {
                    account = JSON.parse(sessionAccount)
                } else if (this.isValid(cookieAccount) && cookieAccount != '') {
                    account = this.getCookie('account')
                }
            }
            return account
        }

        Vue.prototype.isValid = function(value) {
            return value != null && typeof value != 'undefined'
        }

        Vue.prototype.isValidInt = function(prop, minValue) {
            if (!this.isValid(prop) || !$.isNumeric(prop) || prop <= minValue)
                return false

            return true
        }

        Vue.prototype.isValidArray = function(arr) {
            if (!this.isValid(arr) || !this.isValid(arr.length) || arr.length < 1)
                return false
            return true
        }

        Vue.prototype.getResultData = function(data) {
            if (typeof data.result != 'undefined' && data.result != null) {
                return data.result
            }

            return data
        }

        Vue.prototype.getReturnCode = function(data) {
            if (this.isValid(data.ReturnCode)) {
                return data.ReturnCode
            }

            return 0
        }

        Vue.prototype.getResultNextPage = function(data) {

            if (this.isValid(data.NextPage)) {
                return data.NextPage
            }

            return 0
        }

        var g_ajaxQueue = []
        var g_ajaxIsRunning = false
        Vue.prototype.addToQueue = function(methodName, inputObj, handleFunc, target, runNow) {
                g_ajaxQueue.push(this.sendRequest(methodName, inputObj, handleFunc, target))
                if (runNow) {
                    /*
                    axios.all(g_ajaxQueue).then(axios.spread((response) => {
                        console.log(response)
                    }))
                    */
                }
            },

            Vue.prototype.startLoading = function() {
                this.$store.commit('OPEN_LOADING')
            }

        Vue.prototype.stopLoading = function() {
            this.$store.commit('CLOSE_LOADING')
        }

        Vue.prototype.updateSession = function(key, value) {
            sessionStorage[key] = value
        }

        Vue.prototype.sendRequest = function(methodName, inputObj, handleFunc, target, next) {
            if (this.isValid(inputObj)) {
                var dataObj = {}

                var session = this.getSession()
                if (session != null)
                    Object.assign(dataObj, { "session": session })
                else
                    Object.assign(dataObj, { "session": "" })
                if (!this.isValidInt(inputObj.page, -1))
                    inputObj.page = 0

                Object.assign(dataObj, inputObj)

                var contentType = "application/x-www-form-urlencoded"
                var dataType = "json"
                g_ajaxIsRunning = true
                if (!this.isValid(window.ajaxRandomArr)) {
                    window.ajaxRandomArr = []
                }
                window.ajaxRandomArr.push(Math.random())
                axios({
                    url: methodName,
                    method: "post",
                    baseURL: this.getWSDomain(),
                    /*
                    transformRequest: [function(data) {

                        return data
                    }],
                    transformResponse: [function(data) {

                    }],
                    */
                    /*//谨慎使用
                    headers: { 'Access-Control-Allow-Origin': '*' },
                    params: qs.stringify(dataObj),
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrarFormat: 'brackets' })
                    },
                    */
                    data: this.$qs.stringify(dataObj),
                    timeout: 0,
                    withCredentials: false,
                    /*//谨慎使用
                    adapter: function(config) {

                    },
                    */
                    auth: null, //谨慎使用
                    //responseType: dataType,   //谨慎使用
                    xsrfCookieName: 'XSRF-TOKEN',
                    xsrfHeaderName: 'X-XSRF-TOKEN',
                    //maxContentLength: 2000,
                    /*
                    validateStatus: function(status) { //研究一下
                        return status >= 200 && status < 300
                    },
                    maxRedirects: 5,
                    httpAgent: new http.Agent({ keepAlive: true }),
                    httpsAgent: new https.Agent({ keepAlive: true }),
                    proxy: {
                        host: 'ws.ckl.com',
                        port: '80',
                        auth: {}
                    },
                    cancelToken: new axios.CancelToken(function(cancel) {

                    })
                    */
                }).then((response) => {
                    g_ajaxIsRunning = false
                    window.ajaxRandomArr.pop()
                    var d = response.data
                    if (this.isValid(d)) {
                        var rc = this.getReturnCode(d)
                        if (rc == 1) {
                            var np = this.getResultNextPage(d)
                            if (np > 0) {
                                inputObj.page = np
                                this.addToQueue(methodName, inputObj, handleFunc, target, true)
                            }

                            var result = this.getResultData(d)
                            handleFunc(result, target, np)
                                // need get more pages
                        } else if (rc < 1) {
                            // hide waiting msg
                            // return error
                            var result = this.getResultData(d)
                            handleFunc(result, target, 0)
                        }
                    } else {
                        handleFunc(-1, target, 0)
                    }
                }).catch(function(error) {
                    console.log(error)
                    g_ajaxIsRunning = false
                })
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js